<template>
    <div class="page-block__item-wrapper">
        <div class="page-block__item">
            <form @submit.prevent="createUser" class="u-full-width">
                <div class="layout">
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.first_name"
                            :error="form.errors.first('first_name')"
                            :label="trans('user.first_name')"
                            name="first_name"
                            class="u-full-width"
                            required
                            focus
                        />
                    </div>
                    <!--
                 -->
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.last_name"
                            :error="form.errors.first('last_name')"
                            :label="trans('user.last_name')"
                            name="last_name"
                            class="u-full-width"
                            required
                        />
                    </div>
                </div>
                <div class="layout | u-margin-bottom-narrow">
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.email"
                            :error="form.errors.first('email')"
                            :label="trans('user.email')"
                            name="email"
                            class="u-full-width"
                            required
                        />
                    </div>
                    <!--
                 -->
                    <div class="layout__item u-1/2-desk">
                        <single-select
                            v-model="form.role"
                            :error="form.errors.first('role')"
                            :label="trans('user.role')"
                            :options="roles"
                            optionLabel="name"
                            optionValue="slug"
                            name="role"
                            class="u-full-width select--user-role"
                            required
                        />
                    </div>
                </div>
                <nav>
                    <button class="btn btn--ghost | u-margin-bottom-narrow" type="submit" dusk="store-user-button">
                        {{ trans('action.save') }}
                    </button>
                </nav>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        form: {
            type: Object,
            required: true
        },
        roles: {
            type: Array,
            required: true
        }
    },
    methods: {
        /**
         * Submit the create user form.
         */
        createUser() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
